import { useCallback } from "react";

import { useProductPlanI18nFormModelContext } from "../../../../context";

export const usePlanName = () => {
	const { viewModel, onSetViewModel } = useProductPlanI18nFormModelContext();
	const { name } = viewModel;

	const onSetName = useCallback(
		(input: string) => {
			onSetViewModel([{ key: "name", value: { ...name, value: input } }]);
		},
		[name, onSetViewModel],
	);

	return {
		name,
		onSetName,
	};
};
